(function($) {

  const check_page = $('main.werk').length;
  if(!check_page) return;

  // Een aantal controllers werken samen om ales in goede banen te leiden

  const masonryController = new MasonryController();
  masonryController.set_grid( $('#MasonryGrid') );
  masonryController.execute();

  const projectsController = new ProjectsController();
  projectsController.set_panel( $('#ProjectListPanel') );

  const mapController = new MapController();
  mapController.set_panel( $('#ProjectMapPanel') );
  mapController.set_map( document.getElementById('WerkMap') );

  const controlsController = new ControlsController();
  controlsController.set_state_toggle( $('input#WerkState') );
  controlsController.set_filter_button( $('#FilterButton') );
  controlsController.set_close_button( $('.close') );
  controlsController.set_filter_panel( $('#FilterPanel') );

  // Proxy, state-handeling 

  const werk = {
    FEATURED : 1,
    ARCHIVE : 2,
    state : 1, // default,
    set_state : function( newstate ) {
      let oldstate = window.werk.state;
      window.werk.state = newstate;
      masonryController.on_state_change( oldstate, newstate );
      projectsController.on_state_change( oldstate, newstate);
      mapController.on_state_change( oldstate, newstate);
      controlsController.set_filter_button_counter();
      // console.log("state changed", newstate);
      return 'werk - state changed';
    }
  }

  window.werk = werk;
  controlsController.set_filter_button_counter();

  // Test archive :
  // window.werk.set_state( window.werk.ARCHIVE )

})(jQuery);